function hmPackMatch(item, selected) {
  var variants = (item.variants || []).filter(function (variant) {
    return variant && variant.available !== false;
  });
  if (!variants.length) variants = item.variants || [];
  if (variants.length <= 1) return variants[0] || null;
  return (
    variants.find(function (variant) {
      return (variant.options || []).every(function (option, index) {
        return !selected[index] || selected[index] === option;
      });
    }) || null
  );
}

var hmPackFlowLetter = { 1: 'L', 2: 'M', 3: 'R', 4: 'C' };

function hmPackBits(item, selected) {
  return (item.optionNames || [])
    .map(function (name, index) {
      return selected[index];
    })
    .filter(Boolean);
}

function hmPackTeat(extra) {
  var shape = String(extra.teat).replace(/[LMRC]$/i, '');
  var letter = hmPackFlowLetter[Number(extra.flowCode)] || '';
  return letter ? shape + letter : String(extra.teat);
}

/** Código de las cuatro respuestas (M1-M4), solo cifras y en orden; vacío si falta alguna. */
function hmPackChoice() {
  var byStep = {};
  try {
    JSON.parse(sessionStorage.getItem('happymami_teat_codes') || '[]').forEach(function (row) {
      if (row && row.step) byStep[row.step] = String(row.code);
    });
  } catch (e) {}
  var out = '';
  var order = ['M1', 'M2', 'M3', 'M4'];
  for (var i = 0; i < order.length; i += 1) {
    if (!/^[1-3]$/.test(byStep[order[i]] || '')) return '';
    out += byStep[order[i]];
  }
  return out;
}

function hmPackLines(config, picks, extra) {
  extra = extra || {};
  var items = config.items || [];
  if (!items.length) return [];
  var rows = [];
  var ready = true;
  items.forEach(function (item) {
    var selected = picks[item.key] || [];
    var variant = hmPackMatch(item, selected);
    if (!variant) ready = false;
    rows.push({ item: item, variant: variant, selected: selected });
  });
  if (config.wizard && (!extra.teat || !extra.flow)) ready = false;
  if (!ready) return [];
  if (Number(config.price) > 0) {
    if (!config.variantId) return [];
    var properties = {};
    rows.forEach(function (row) {
      var bits = hmPackBits(row.item, row.selected);
      if (row.item.title && bits.length) properties[row.item.title] = bits.join(' · ');
    });
    if (config.wizard) {
      properties.Tetina = hmPackTeat(extra);
      properties.Flujo = extra.flow;
      if (hmPackChoice()) properties._hm_choice = hmPackChoice();
    }
    // Piezas del pack con su SKU (oculto): el ERP desglosa el pack sin depender de los textos del idioma.
    var pieces = rows
      .map(function (row) {
        return (row.variant && row.variant.sku) || '';
      })
      .filter(Boolean);
    if (config.wizard && extra.teat) pieces.push(hmPackTeat(extra));
    if (pieces.length) properties._hm_pieces = pieces.join(',');
    return [{ id: config.variantId, quantity: 1, properties: properties, price: Number(config.price) }];
  }
  var bundle = 'pack-' + Date.now().toString(36);
  return rows.map(function (row) {
    var properties = { _bundle_id: bundle, _bundle_title: config.title || 'Pack', _tipo: 'pack' };
    (row.item.optionNames || []).forEach(function (name, index) {
      var value = row.selected[index];
      if (name && value && name.charAt(0) !== '_') properties[name] = value;
    });
    if (config.wizard && row.item.wizard) {
      properties.Tetina = hmPackTeat(extra);
      properties.Flujo = extra.flow;
      if (hmPackChoice()) properties._hm_choice = hmPackChoice();
    }
    return { id: row.variant.id, quantity: 1, properties: properties, price: row.variant.price || 0 };
  });
}

function hmPackShownCents(config, picks) {
  if (Number(config.price) > 0) return Number(config.price);
  return (config.items || []).reduce(function (sum, item) {
    var variant = hmPackMatch(item, (picks && picks[item.key]) || []);
    return sum + ((variant && variant.price) || 0);
  }, 0);
}

function hmPackMoney(cents) {
  return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
}

if (typeof document === 'undefined') {
  var config = {
    title: 'Pack',
    variantId: 9,
    price: 2990,
    items: [
      {
        key: '1',
        title: 'Termo',
        optionNames: ['Color'],
        variants: [
          { id: 1, available: true, price: 1995, options: ['Menta Suave'] },
          { id: 2, available: true, price: 1995, options: ['Rosa Palo'] },
        ],
      },
      {
        key: '2',
        title: 'Dosificador',
        optionNames: ['Color'],
        variants: [{ id: 3, available: true, price: 1595, options: ['Rosa Palo'] }],
      },
    ],
  };
  var lines = hmPackLines(config, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] });
  if (lines.length !== 1 || lines[0].id !== 9 || lines[0].price !== 2990) throw new Error('pack');
  if (lines[0].properties.Termo !== 'Rosa Palo' || lines[0].properties.Dosificador !== 'Rosa Palo') throw new Error('option');
  if (hmPackLines(config, { 1: ['No existe'], 2: ['Rosa Palo'] }).length !== 0) throw new Error('incomplete');
  var wizardConfig = { title: 'Pack', variantId: 9, price: 2990, wizard: 'biberon', items: config.items };
  if (hmPackLines(wizardConfig, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] }, {}).length !== 0) throw new Error('wizard-gate');
  var designed = hmPackLines(wizardConfig, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] }, { teat: 'T2', flow: '3-6 meses', flowCode: '2' });
  if (designed.length !== 1 || designed[0].properties.Tetina !== 'T2M' || designed[0].properties.Flujo !== '3-6 meses') throw new Error('wizard');
  if (designed[0].properties._hm_choice) throw new Error('choice-without-answers');
  var store = {};
  global.sessionStorage = { getItem: function (key) { return store[key] || null; } };
  store.happymami_teat_codes = JSON.stringify([
    { step: 'M2', code: '1' }, { step: 'M1', code: '2' }, { step: 'M4', code: '1' }, { step: 'M3', code: '1' },
  ]);
  var coded = hmPackLines(wizardConfig, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] }, { teat: 'T2', flow: '3-6 meses', flowCode: '2' });
  if (coded[0].properties._hm_choice !== '2111') throw new Error('choice-order');
  store.happymami_teat_codes = JSON.stringify([{ step: 'M1', code: '2' }, { step: 'M2', code: '1' }]);
  if (hmPackLines(wizardConfig, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] }, { teat: 'T2', flow: 'x', flowCode: '2' })[0].properties._hm_choice) throw new Error('choice-partial');
  delete global.sessionStorage;
  if (hmPackMoney(lines[0].price) !== '29,90 €') throw new Error('money');
  var summed = hmPackLines({ title: 'Pack', variantId: 9, price: 0, items: config.items }, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] });
  if (summed.length !== 2 || summed[0].id !== 2 || summed[1].id !== 3) throw new Error('sum-lines');
  if (summed[0].properties._bundle_id !== summed[1].properties._bundle_id) throw new Error('sum-group');
  if (hmPackShownCents({ price: 0, items: config.items }, { 1: ['Rosa Palo'], 2: ['Rosa Palo'] }) !== 3590) throw new Error('sum');
  console.log('hm-pack ok');
} else {
  (function () {
    if (window.__hmPack) return;
    window.__hmPack = true;

    function boot() {
      var root = document.getElementById('happymami-pack');
      var cfgEl = document.getElementById('happymami-pack-config');
      if (!root || !cfgEl || root.dataset.hmBound) return;
      root.dataset.hmBound = '1';
      var config = {};
      try {
        config = JSON.parse(cfgEl.textContent || '{}');
      } catch (e) {
        config = {};
      }

      function picks() {
        var selected = {};
        (config.items || []).forEach(function (item) {
          selected[item.key] = [];
          root.querySelectorAll('.hm-extra-choice.is-selected[data-hm-extra-key="' + item.key + '"]').forEach(function (btn) {
            selected[item.key][Number(btn.getAttribute('data-hm-extra-option'))] = btn.getAttribute('data-value');
          });
        });
        return selected;
      }

  function hmMsg(path, fallback, vars) {
    if (typeof window.hmT === 'function') {
      var t = window.hmT(path, vars);
      if (t) return t;
    }
    return fallback;
  }

  var flowLabel = {
    1: hmMsg('flow.flow_0_3', '0-3 meses'),
    2: hmMsg('flow.flow_3_6', '3-6 meses'),
    3: hmMsg('flow.flow_6_plus', '+6 meses'),
    4: hmMsg('flow.flow_pures', 'Papillas y purés'),
  };

      function readTeat() {
        try {
          return sessionStorage.getItem('happymami_teat_sku') || '';
        } catch (e) {
          return '';
        }
      }

      function extra() {
        var btn = root.querySelector('[data-hm-flow].is-selected');
        var code = btn ? btn.getAttribute('data-hm-flow') : '';
        return {
          teat: root._hmTeat || readTeat(),
          flowCode: code,
          flow: code ? flowLabel[Number(code)] || btn.textContent.trim() : '',
        };
      }

      var swatchFallback = { 'Menta Suave': '#b7d4c8', 'Rosa Palo': '#e8b4ae', 'Violeta Seda': '#6f6280' };

      function paintSwatches() {
        var colors = Object.assign({}, swatchFallback, config.colorHex || {});
        root.querySelectorAll('.hm-swatch').forEach(function (btn) {
          var name = btn.getAttribute('data-value') || '';
          var hex = btn.getAttribute('data-hm-hex') || colors[name];
          if (!hex && name) {
            var lower = name.toLowerCase();
            Object.keys(colors).some(function (key) {
              if (key.toLowerCase() === lower) {
                hex = colors[key];
                return true;
              }
              return false;
            });
          }
          if (!hex) return;
          btn.style.setProperty('--hm-swatch', hex);
          btn.style.backgroundColor = hex;
        });
      }

      function readChoices() {
        try {
          var parsed = JSON.parse(sessionStorage.getItem('happymami_teat_choices') || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }

      function renderDesign(choices, teatSku) {
        var box = root.querySelector('[data-hm-design]');
        var list = root.querySelector('[data-hm-design-list]');
        if (!box || !list) return;
        var picked = choices && choices.length ? choices : readChoices();
        var rows = (picked || []).filter(function (row) {
          return row && (row.titulo || row.opcion) && row.step !== 'M5';
        });
        if (typeof window.happymamiLocalizeChoices === 'function') rows = window.happymamiLocalizeChoices(rows);
        if (!rows.length && teatSku) rows = [{ titulo: 'Tetina', opcion: teatSku }];
        if (!rows.length) {
          list.innerHTML = '<div>' + hmMsg('pack.custom_teats', 'Tu tetina a medida') + '</div>';
          return;
        }
        list.innerHTML = rows
          .map(function (row, index) {
            var title = String(row.titulo || '').replace(/</g, '');
            var option = String(row.opcion || '').replace(/</g, '').replace(/\n/g, ' ');
            var step = String(row.step || ['M1', 'M2', 'M3', 'M4'][index] || '').replace(/[^\w]/g, '');
            var inner = '<span class="hm-design__label">' + title + ': </span><span class="hm-design__value">' + option + '</span>';
            if (!step) return '<div>' + inner + '</div>';
            return '<button type="button" class="hm-design__row" data-hm-edit-step="' + step + '">' + inner + '</button>';
          })
          .join('');
      }

      function showWizard(edit) {
        var wizard = document.getElementById('happymami-wizard-container');
        var after = root.querySelector('[data-hm-pack-after]');
        if (after) after.hidden = true;
        if (wizard) wizard.hidden = false;
        document.dispatchEvent(new CustomEvent('happymami:edit', { bubbles: true, detail: edit || { mode: 'all', codes: [], choices: readChoices() } }));
      }

      function showAfter() {
        var wizard = document.getElementById('happymami-wizard-container');
        var after = root.querySelector('[data-hm-pack-after]');
        if (wizard) {
          wizard.hidden = true;
          wizard.classList.remove('is-invalid');
        }
        if (after) after.hidden = false;
      }

      function visible(el) {
        return !!(el && !el.hidden && !el.closest('[hidden]'));
      }

      function markMissing() {
        var missing = [];
        root.querySelectorAll('.is-invalid').forEach(function (el) {
          el.classList.remove('is-invalid');
        });
        root.querySelectorAll('[data-hm-required]').forEach(function (group) {
          if (!visible(group)) return;
          if (!group.querySelector('.is-selected')) {
            group.classList.add('is-invalid');
            missing.push(group);
          }
        });
        if (config.wizard && !extra().teat) {
          var wizard = document.getElementById('happymami-wizard-container');
          if (wizard) {
            wizard.classList.add('is-invalid');
            missing.unshift(wizard);
          }
        }
        if (missing[0] && window.happymamiFlow) window.happymamiFlow.scrollTo(missing[0]);
        else if (missing[0] && missing[0].scrollIntoView) missing[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function update() {
        var lines = hmPackLines(config, picks(), extra());
        var ready = lines.length > 0;
        var button = root.querySelector('[data-hm-pack-add]');
        var label = root.querySelector('[data-hm-pack-label]');
        if (button) button.disabled = false;
        if (label) {
          label.textContent = ready
            ? hmMsg('bundle.add_to_cart', 'Añadir al carrito')
            : hmMsg('bundle.choose_options', 'Elegir opciones');
        }
        if (!(Number(config.price) > 0)) {
          var shown = hmPackMoney(hmPackShownCents(config, picks()));
          root.querySelectorAll('.hm-pack-buy__offer .price-item--regular, .hm-pack-buy__price').forEach(function (node) {
            node.textContent = shown;
          });
        }
        (config.items || []).forEach(function (item) {
          var variant = hmPackMatch(item, picks()[item.key] || []);
          var img = root.querySelector('[data-hm-extra="' + item.key + '"] .hm-preview__img.is-on');
          if (img && variant && variant.image) img.src = variant.image;
        });
        root._hmLines = ready ? lines : [];
      }

      root._hmTeat = readTeat();
      paintSwatches();
      if (root._hmTeat) renderDesign(readChoices(), root._hmTeat);

      root.addEventListener('click', function (event) {
        var flow = event.target.closest && event.target.closest('[data-hm-flow]');
        if (flow && root.contains(flow)) {
          root.querySelectorAll('[data-hm-flow]').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          flow.classList.add('is-selected');
          var flowBox = flow.closest('[data-hm-required]');
          if (flowBox) flowBox.classList.remove('is-invalid');
          update();
          return;
        }
        var btn = event.target.closest && event.target.closest('.hm-extra-choice');
        if (!btn || !root.contains(btn)) return;
        var key = btn.getAttribute('data-hm-extra-key');
        var option = btn.getAttribute('data-hm-extra-option');
        root
          .querySelectorAll('.hm-extra-choice[data-hm-extra-key="' + key + '"][data-hm-extra-option="' + option + '"]')
          .forEach(function (el) {
            el.classList.remove('is-selected');
          });
        btn.classList.add('is-selected');
        var box = btn.closest('[data-hm-required]');
        if (box) box.classList.remove('is-invalid');
        update();
      });

      var designToggle = root.querySelector('[data-hm-design-toggle]');
      if (designToggle) {
        designToggle.addEventListener('click', function () {
          var box = root.querySelector('[data-hm-design]');
          if (!box) return;
          var closed = box.classList.toggle('is-closed');
          designToggle.setAttribute('aria-expanded', closed ? 'false' : 'true');
        });
      }

      var designList = root.querySelector('[data-hm-design-list]');
      if (designList) {
        designList.addEventListener('click', function (event) {
          var stepBtn = event.target.closest && event.target.closest('[data-hm-edit-step]');
          if (!stepBtn) return;
          showWizard({ mode: 'one', step: stepBtn.getAttribute('data-hm-edit-step'), choices: readChoices() });
        });
      }

      var edit = root.querySelector('[data-hm-pack-edit]');
      if (edit) {
        edit.addEventListener('click', function () {
          showWizard({ mode: 'all', choices: readChoices() });
        });
      }

      document.addEventListener('happymami:pharma-ready', function () {
        if (!root._hmTeat && !readTeat()) return;
        renderDesign(readChoices(), root._hmTeat || readTeat());
      });

      document.addEventListener('happymami:complete', function (event) {
        var detail = (event && event.detail) || {};
        root._hmTeat = detail.teat || detail.ref || readTeat();
        renderDesign(detail.choices && detail.choices.length ? detail.choices : readChoices(), root._hmTeat);
        showAfter();
        update();
      });

      root.querySelector('[data-hm-pack-add]').addEventListener('click', function () {
        var lines = root._hmLines || [];
        if (!lines.length) {
          markMissing();
          return;
        }
        var button = root.querySelector('[data-hm-pack-add]');
        button.disabled = true;
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        if (!/\.js(\?|$)/.test(addUrl)) addUrl += '.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: lines.map(function (line) {
              return { id: line.id, quantity: 1, properties: line.properties };
            }),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error((data && (data.description || data.message)) || hmMsg('pack.add_error', 'No se ha podido añadir'));
              return data;
            });
          })
          .then(function (data) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
          })
          .catch(function (error) {
            window.alert(error.message || hmMsg('pack.add_error', 'No se ha podido añadir'));
          })
          .then(function () {
            update();
          });
      });

      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();
}
